import * as url from "../url_helper";

import { post } from "../api_helper";

export const getSignupInquiryList = data => post(url.GET_SIGNUP_INQUIRY_LIST, data);

export const addSignupInquiry = data => post(url.ADD_SIGNUP_INQUIRY, data, {skipInterceptor: true});

export const editSignupInquiryList = data => post(url.EDIT_SIGNUP_INQUIRY, data);

export const getOneSignupInquiryList = data => post(url.GET_ONE_SIGNUP_INQUIRY, data);

export const getStateListForInquiry = data => post(url.GET_STATE_LIST, data, {skipInterceptor: true});

